import React, { useState, useEffect } from "react"
import styled from "styled-components"
import { Link, useStaticQuery, graphql } from "gatsby" // Link Read his...
//@ts-ignore
import RightArrow from "../../assets/rightArrow.svg"

const RecWeekSection = styled.section`
  display: flex;
  justify-content: center;
  padding-top: 58px;
  padding-bottom: 80px;
`

const CheatWrapper = styled.div`
  max-width: 1040px;
  @media screen and (max-width: 1070px) {
    max-width: 900px;
  }
  @media screen and (max-width: 915px) {
    max-width: 750px;
  }
  @media screen and (max-width: 818px) {
    max-width: 600px;
  }
  @media screen and (max-width: 670px) {
    max-width: 450px;
  }
  @media screen and (max-width: 518px) {
    max-width: 350px;
  }
  @media screen and (max-width: 422px) {
    max-width: 300px;
  }
  @media screen and (max-width: 387px) {
    max-width: 225px;
  }
`

const ContentWrapper = styled.section`
  h2 {
    font-family: "Amasis", serif;
    font-size: 26px;
    font-weight: 700;
  }

  p {
    width: 95%;
    margin: 30px 0;
  }
`

const ArmWrapper = styled.section`
  margin: 32px 0 45px 0;
  .header {
    margin-bottom: 18px;
    font-family: "Tinos", serif;
    font-size: 22px;
    font-style: italic;
    font-weight: 700;
    color: #989085;
  }
`

const ArmBoxes = styled.div`
  display: flex;
  font-family: "Amasis", serif;

  :hover{
    cursor: pointer;
  }

  .active-tab {
    border: 2px solid #461459;
    box-shadow: 3px 3px #461459;
  }

  @media screen and (max-width: 915px) {
    flex-direction: column;
  }
`

const ArmBox = styled.div`
  background: #F9F3EC;
  border: 1px solid #C6BCAF;
  margin-right: 20px;
  padding: 16px 72px;
  padding-left: 16px;

  @media screen and (max-width: 915px) {
    padding-right: 0;
    margin-right: 0;
    margin-bottom: 20px;
  }
  @media screen and (max-width: 387px) {
    font-size: 12px;
  }
`

const Staffers = styled.section`
  display: flex;
  flex-direction: column;
  .header {
    margin-bottom: 18px;
    font-family: "Tinos", serif;
    font-size: 22px;
    font-style: italic;
    font-weight: 700;
    color: #989085;
  }
`
const StaffersBoxes = styled.section`
  display: flex;
  flex-direction: row;
  @media screen and (max-width: 915px) {
    flex-direction: column;
  }
`
const StaffersBox = styled.section`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background-color: #f9f3ec;
  width: 100%;
  height: 400px;
  margin-right: 21px;
  padding-top: 22px;
  padding-left: 19px;
  padding-right: 15px;
  padding-bottom: 27px;
  h2 {
    font-family: "Amasis", serif;
    font-size: 26px;
    font-weight: 700;
  }
  p {
    font-family: Cabin;
    font-size: 12px;
    margin-top: 10px;
    line-height: 1.7;
  }
  span {
    font-family: "Tinos", serif;
    font-size: 16px;
    font-style: italic;
    font-weight: 700;
    color: #6b3e7d;
    margin-top: 19px;
  }
  a {
    color: #6b3e7d;
    text-decoration: none;
  }
  @media screen and (max-width: 1260px) {
    height: auto;
  }
  @media screen and (max-width: 915px) {
    margin-top: 20px;
  }
`
const StaffersWrapper = styled.section`
  max-width: 1040px;
  @media screen and (max-width: 1070px) {
    max-width: 900px;
  }
  @media screen and (max-width: 915px) {
    max-width: 750px;
  }
  @media screen and (max-width: 818px) {
    max-width: 600px;
  }
  @media screen and (max-width: 670px) {
    max-width: 450px;
  }
  @media screen and (max-width: 518px) {
    max-width: 350px;
  }
  @media screen and (max-width: 422px) {
    max-width: 300px;
  }
  @media screen and (max-width: 387px) {
    max-width: 225px;
  }
`

const RecWeek: React.FC<{}> = function (data) {

  const { description, join, englishStaff, bagwisanStaff, artStaff, productionStaff, designStaff, heightsOnlineStaff } = data.data
  
  const deliberatingArm = [englishStaff, bagwisanStaff, artStaff]
  const organizationalArm = [productionStaff, designStaff, heightsOnlineStaff]
  
  const [tab, setTab] = useState(0)
  const [staffers, setStaffers] = useState(deliberatingArm)

  useEffect(() => {
    tab === 0 ? setStaffers(deliberatingArm) : setStaffers(organizationalArm)
  }, [tab])

  return (
    <RecWeekSection>
      <CheatWrapper>
        <ContentWrapper>
          <h2>Become a Heightser!</h2>
          <p>{description.description}</p>
          <p>{join.join}</p>
        </ContentWrapper>
        <ArmWrapper>
          <h2 className="header">Select your arm</h2>
          <ArmBoxes>
            <ArmBox className={tab === 0 ? "tab active-tab" : "tab"} onClick={() => setTab(0)}>
              <h2>Deliberating Arm</h2>
            </ArmBox>
            <ArmBox className={tab === 1 ? "tab active-tab" : "tab"} onClick={() => setTab(1)}>
              <h2>Organizational Arm</h2>
            </ArmBox>
          </ArmBoxes>
        </ArmWrapper>
        <StaffersWrapper>
          <Staffers>
            <h2 className="header">Other Staffs</h2>
            <StaffersBoxes>
              {staffers.map(staffer => {
                const { title, description, submissionDetails, requirements } = staffer
                console.log(staffer)
                return (
                  <StaffersBox>
                    <div>
                      <h2>{title}</h2>
                      <p>{description.description}</p>
                      <br />
                      <p>{submissionDetails.submissionDetails}</p>
                    </div>
                    <span>
                      <Link to={requirements} target="_blank">
                        See Requirements
                        <img style={{ marginLeft: "10px" }} src={RightArrow} alt="" />
                      </Link>
                    </span>
                  </StaffersBox>
                )
              })}
            </StaffersBoxes>
          </Staffers>
        </StaffersWrapper>
      </CheatWrapper>
    </RecWeekSection>
  )
}

export default RecWeek
